import { useGql } from '#imports'
import { getSdk as adminApiGqlSdk } from '#gql/adminApi'
export const GqlSdks = {
  adminApi: adminApiGqlSdk,
}
export const GqClientOps = {"adminApi":["AccountDetail","AccountCustomMenuItemsTree","PublicCustomPage"]}
export const GqlAccountCustomMenuItemsTree = (...params) => useGql()('AccountCustomMenuItemsTree', ...params)
export const GqlAccountDetail = (...params) => useGql()('AccountDetail', ...params)
export const GqlPublicCustomPage = (...params) => useGql()('PublicCustomPage', ...params)